import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Wird beim Admin-Login gesetzt: eigene Besuche fließen dann nicht in die Statistik
export const INTERN_KEY = "ls_intern_besuch";
export const istIntern = () => localStorage.getItem(INTERN_KEY) === "1";

/**
 * Privatsphären-freundlicher Pageview-Tracker (kein Cookie, keine externen Dienste).
 * Wird bei jedem Route-Wechsel automatisch getriggert.
 * Admin-Bereiche und eigene Besuche werden ausgefiltert.
 */
export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin") || path.startsWith("/anfrage/token")) return;
    if (istIntern()) return;   // eigener Besuch — nicht mitzählen

    // Fire and forget — kein await, kein Fehler-Handling nötig
    axios
      .post(`${API}/analytics/pageview`, {
        path,
        referrer: document.referrer || "",
      })
      .catch(() => {
        /* Statistik-Fail ist non-fatal */
      });
  }, [location.pathname]);

  return null;
}
